function hasLocalStorage() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
}

export function storageGet(key) {
  if (!hasLocalStorage()) return null
  try {
    return window.localStorage.getItem(key)
  } catch (error) {
    console.warn(`Falha ao ler localStorage (${key}).`, error)
    return null
  }
}

export function storageSet(key, value) {
  if (!hasLocalStorage()) return false
  try {
    window.localStorage.setItem(key, value)
    return true
  } catch (error) {
    console.warn(`Falha ao gravar localStorage (${key}).`, error)
    return false
  }
}

export function storageRemove(key) {
  if (!hasLocalStorage()) return false
  try {
    window.localStorage.removeItem(key)
    return true
  } catch (error) {
    console.warn(`Falha ao remover localStorage (${key}).`, error)
    return false
  }
}
